function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import WMSMapLayer from '@domain-group/fe-allhomes-library/lib/enums/wms-map-layer';
import WMSMapLayerLegend from '@domain-group/fe-allhomes-library/lib/enums/wms-map-layer-legend';
import { SCHOOL_LAYER_DEFAULT, SCHOOL_LAYER_HIGH_SCHOOL, SCHOOL_LAYER_COLLEGE } from '../../enums/advanced-option';
import GenericPanel from './generic-panel';
import SchoolPanel from './school-panel';
import LandContourPanel from './land-contour-panel';
import ParentPanel from './parent-panel';

/* eslint-disable no-unreachable */
import { jsx as ___EmotionJSX } from "@emotion/core";
var PanelSwitch = props => {
  var resetPanel = () => {
    props.onUpdateOverlay(null);
  };
  switch (props.enabledOverlay && props.enabledOverlay.id) {
    case SCHOOL_LAYER_DEFAULT:
    case SCHOOL_LAYER_HIGH_SCHOOL:
    case SCHOOL_LAYER_COLLEGE:
      return ___EmotionJSX(SchoolPanel, {
        title: WMSMapLayerLegend.ACT_SCHOOLS.title,
        description: WMSMapLayerLegend.ACT_SCHOOLS.description,
        selected: props.enabledOverlay.id,
        onSelect: selection => {
          props.onUpdateSchool(selection);
        },
        onBack: resetPanel
      });
    case WMSMapLayer.TP_ZONES.id:
      return ___EmotionJSX(GenericPanel, _extends({
        legendColumns: 4,
        onBack: resetPanel
      }, props.legend));
    case WMSMapLayer.EASEMENTS.id:
      return ___EmotionJSX(GenericPanel, _extends({
        legendColumns: 2,
        onBack: resetPanel
      }, props.legend));
    case WMSMapLayer.UNIMPROVED_LAND_VALUES.id:
      return ___EmotionJSX(GenericPanel, {
        onBack: resetPanel,
        title: "Unimproved land values",
        description: "The value of a block of land without any buildings, landscaping, paths, or fences.<br/>This is different to the block's market value. A block's unimproved value is used to calculate rates and land tax charges."
      });
    case WMSMapLayer.CONTOURS.id:
      return ___EmotionJSX(LandContourPanel, {
        onBack: resetPanel
      });
    default:
      return ___EmotionJSX(ParentPanel, {
        disabled: props.disabled,
        onSelect: selection => {
          var isSchool = isEqual(selection, SCHOOL_LAYER_DEFAULT);
          props.onUpdateOverlay(selection, isSchool);
          if (isSchool) {
            props.onUpdateSchool(selection);
          }
        }
      });
  }
};
PanelSwitch.propTypes = {
  legend: PropTypes.shape(GenericPanel.propTypes),
  enabledOverlay: PropTypes.shape({
    id: PropTypes.string
  }),
  onUpdateOverlay: PropTypes.func,
  onUpdateSchool: PropTypes.func,
  disabled: PropTypes.bool
};
PanelSwitch.defaultProps = {
  legend: null,
  enabledOverlay: null,
  onUpdateOverlay: () => {},
  onUpdateSchool: () => {},
  disabled: false
};
export default PanelSwitch;